import { Typography } from '@mui/material'
import React from 'react'
import * as datefns from 'date-fns'
import { sv } from 'date-fns/locale'

// import { useTranslation } from 'react-i18next'

function IssueStatusDescription({ hideUntil, stage, isComplete, shortForm = false }) {
    const issueStatusLabels = {
        1: 'Offentliggörande',
        2: 'Villkor',
        3: 'Prospekt',
        4: 'Utfall',
        5: 'Avbruten',
        10: 'Skapad',
    }
    let stageLabel = issueStatusLabels[stage] || `Annat: ${stage}`
    let sx = { color: isComplete ? 'green' : 'red' }
    if (!stage) {
        return null
    }
    if (stage === 10 && isComplete) {
        // this is the "all done" status, no need to show anything
        return (
            <Typography
                variant='body1'
                gutterBottom
                sx={[
                    {
                        display: 'block',
                    },
                    ...(Array.isArray(sx) ? sx : [sx]),
                ]}
            >
                Klar
            </Typography>
        )
    }
    if (hideUntil && new Date(hideUntil) > new Date()) {
        // if hideUntil is a string, make a Date from it
        if (typeof hideUntil === 'string') {
            hideUntil = new Date(hideUntil)
        }
        let sx = { color: 'orange' }
        return (
            <Typography
                variant='body1'
                gutterBottom
                sx={[
                    {
                        display: 'block',
                    },
                    ...(Array.isArray(sx) ? sx : [sx]),
                ]}
            >
                {!shortForm && `Steg: ${stageLabel}. Avvakta till: ${datefns.format(hideUntil, 'yyyy-MM-dd')}`}
                {shortForm && `Avvakta till ${datefns.format(hideUntil, 'MMM d', { locale: sv })}.`}
            </Typography>
        )
    }
    return (
        <Typography
            variant='body1'
            gutterBottom
            sx={[
                {
                    display: 'block',
                },
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
        >
            {stageLabel}, {isComplete ? 'klar' : 'inte klar'}.
        </Typography>
    )
}

export { IssueStatusDescription }
